// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"authenticationLayout_wrapper__zz6gF","main":"authenticationLayout_main__1ja0y"};